import merge from "deepmerge";
import { getBasket } from "./getBasket";
import { Variant, Product } from "../../types/types";
import { generatePageLoadAnalyticsDataLayer } from "./generatePageLoadAnalyticsDataLayer";
import { generatePromotionClassifications } from "./helpers";

declare const window: any; // eslint-disable-line @typescript-eslint/no-explicit-any

const ANALYTICS_EVENT_NAME = "dataStateChange";

const analyticsReady = () => {
  return (
    window && window.Bootstrapper && window.Bootstrapper.dataStateChangeReady
  );
};

const dispatchEvent = (
  action: string,
  payload: any, // eslint-disable-line @typescript-eslint/no-explicit-any
  jlData?: {
    [key: string]: unknown;
  },
) => {
  if (jlData) setAnalyticsData(jlData);

  document.body.dispatchEvent(
    new CustomEvent(ANALYTICS_EVENT_NAME, {
      detail: {
        action,
        ...payload,
      },
    }),
  );
};

const setAnalyticsData = (payload = {}) => {
  const currentJLData = window.jlData || {};
  const mergePromotionClassificiations = (
    _currentPromotionClassifications: { group: string; type: string }[],
    newPromotionClassifications: { group: string; type: string }[],
  ) => newPromotionClassifications;

  const options = {
    customMerge: (key: string) => {
      if (key === "promotionClassifications") {
        return mergePromotionClassificiations;
      }
      return;
    },
  };

  const newJLData = merge(currentJLData, payload, options);
  window.jlData = newJLData;
};

const updateBasketAnalyticsObject = () => {
  const basket = getBasket();
  window.jlData = { ...window.jlData, basket };
};

export const dispatchAnalyticsEvent = (
  action: string,
  payload: any, // eslint-disable-line @typescript-eslint/no-explicit-any
  jlData: {
    [key: string]: unknown;
  },
) => {
  updateBasketAnalyticsObject();
  if (analyticsReady()) {
    dispatchEvent(action, payload, jlData);
  } else {
    document.body.addEventListener(
      "EnsightenReady",
      () => dispatchEvent(action, payload, jlData),
      { once: true },
    );
  }
};

export const dispatchVariantChangedAnalyticsEvent = (
  type: string,
  selectedVariant: Variant,
  product: Product,
) => {
  dispatchAnalyticsEvent(
    "pdp.productSkuChanged",
    { type },
    {
      page: {
        productPages: {
          size: selectedVariant.differentiators?.size,
          colour: selectedVariant.differentiators?.colour,
          displayedSku: selectedVariant?.aliases?.skuId,
          emwbisForm: selectedVariant?.customerNotifiableEvents?.backInStock,
          price: selectedVariant?.price?.value,
          promotionClassifications: generatePromotionClassifications(
            product,
            selectedVariant,
          ),
        },
      },
    },
  );
};

export const dispatchPageLoadAnalyticsEvent = (
  product: Product,
  selectedVariant: Variant,
  pageConfigName?: string,
) => {
  dispatchAnalyticsEvent(
    "pageload",
    {},
    generatePageLoadAnalyticsDataLayer(
      product,
      selectedVariant,
      pageConfigName,
    ),
  );
};
